import React from 'react'
import { NOT_AVAILABLE } from '../../../../utils/constants'
import {
  EllipsisContainer,
  TooltipWrapper,
  CurrentPlatformTypeText,
} from '../../../Global'

export const TableDataCellPlatformType = ({
  dataValue = NOT_AVAILABLE,
}: {
  dataValue?: string
}) => {
  return (
    <TooltipWrapper showTooltip={true} tooltip={dataValue}>
      <EllipsisContainer maxWidth="240px">
        <CurrentPlatformTypeText platformType={dataValue} />
      </EllipsisContainer>
    </TooltipWrapper>
  )
}
